module.exports = __webpack_public_path__ + "static/media/light-theme-running.c77ebe6d.svg";